import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import Request from "../../../components/SidebarMenuComponents/ApprovalComponent/Request";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function RequestPage() {
    const location = useLocation();
    const requestMaster = location.state;
    console.log("requestMaster", requestMaster);
    return (
        <Page title="Request Category Master| tiketic" >
          
            <StickyHeader title="Request Category Master" />

            <ContentStyle>
                <Request requestMaster={requestMaster}/>
            </ContentStyle>
        </Page>
    );
}

